<template>
  <div class="card">

    <div class="bg-blue-light p-1">
      <TitleButton
          :showBtn="false"
          :showAddNew="false"
          title="Opd Billing Report"
      /> 
    </div>

    <div class="my-2 px-2">
      <DateQuerySetter
          btnTitle="Go"
          @onClickGo="getOpdBillingReport"
      >
        <div class="col-12 col-sm-6 col-md-5 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Roles</label>
          <v-select
            placeholder="Select Roles"
            v-model="roleIds"
            :options="companyRoles"
            label="name"
            :reduce="name => name.id"
            multiple
          />
        </div>
      </DateQuerySetter>
    </div>

    <div class="d-flex justify-content-end px-2 mb-2 gap-1">
      <button class="btn btn-primary btn-block waves-effect waves-float waves-light" @click="goToPrint">
        Print
      </button>
    </div>

    <div class="col-12 px-2">
      <ListTable :report-list="reportList"/>
    </div>

    <Loader v-if="loading"/>
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {useRoute, useRouter} from 'vue-router';
import DateQuerySetter from '@/components/atom/DateQuerySetter';
import ListTable from '@/components/molecule/company/hospital/hospital-admin/OpdBillingReportTable.vue';
import handleHospitalReport from "@/services/modules/hospital/report";
import {computed, inject, onMounted, ref} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import handleCompany from "@/services/modules/company";
import pdfPrinter from '@/services/utils/pdf/opdSalesReport';
import handleRole from "@/services/modules/role";

const { fetchCompanyInfo } = handleCompany();
const { fetchOpdBillingReport } = handleHospitalReport();
const { exportToPDF } = pdfPrinter();
const { fetchCompanyDefaultRoles } = handleRole();

const showError = inject('showError');
const showSuccess = inject('showSuccess');
const route = useRoute();
const router = useRouter();
const loading = ref(false);
const companyInfo = ref({})
const reportList = ref([]);
const companyRoles = ref([]);
const roleIds = ref([]);

//computed
const companyId = computed(() => route.params.companyId);
const startDate = computed(() => route.query.start);
const endDate = computed(() => route.query.end);

//methods
const goToPrint = async() => {
  let date = {
    start_date: startDate.value,
    end_date: endDate.value
  }
  fetchCompanyInfo(companyId.value).then((res) => {
    companyInfo.value = res.data
  }).then(() => {
    exportToPDF(companyInfo.value, reportList.value, date)
  })
}

const getQuery = () => {
  let query = '?company_id=' + companyId.value

  if (!startDate.value && !endDate.value) return query
  if (startDate.value) query += '&start_date=' + startDate.value
  if (endDate.value) query += '&end_date=' + endDate.value
  if (roleIds.value && roleIds.value.length > 0) {
    query += '&role_ids=' + roleIds.value.join(',');
  }

  return query
};

const getOpdBillingReport = async () => {
  await fetchOpdBillingReport(getQuery()).then((res) => {
    if(! res.status) {
      showError(res.message)
    }
    reportList.value = res.data;
  }).catch((err) => {
    loading.value = false
  }).finally(() => {
    loading.value = false
  })
};

const getCompanyRoles = async () => {
  try {
    const companyQuery = '?company_id=' + companyId.value;
    const res = await fetchCompanyDefaultRoles(companyQuery);
    companyRoles.value = res.data;
  } catch (error) {
      showError('Something went wrong');
  }
};

onMounted(async () => {
  await getCompanyRoles();
  await getOpdBillingReport();
})
</script>
